<div>
  <s-form-input-enum
    [label]="label"
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [defaultText]="defaultText"
    [apiError]="apiError"
    [enumObject]="dayOfWeek"
    [mapping]="dayOfWeekMapping"
    [schema]="schema"
    [filter]="filter"
    [displayHint]="displayHint"
  />
</div>
